import {getNormalizedShortcut} from 'util/Keyboard';
import {ElementKeyboardEvent} from 'util/Types';

export function isSwitchTabLeft(e: KeyboardEvent | ElementKeyboardEvent): boolean {
  return getNormalizedShortcut(e) === 'Ctrl + Shift + 9';
}

export function isSwitchTabRight(e: KeyboardEvent | ElementKeyboardEvent): boolean {
  return getNormalizedShortcut(e) === 'Ctrl + Shift + 0';
}
